export default __webpack_public_path__ + "static/media/bookmark.ba795f58.svg";